<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol col="8" style="text-align: start">

                                <strong>{{$t('InventoryAdjustment')}}</strong>

                            </CCol>

                            <CCol col="4" style="text-align: end">
                              <CRow>
                                <CCol col="12" style="text-align: end">
                                  <CButton class="mr-1 ml-1"
                                           @click="change_refer_modal=true"
                                           size="sm"
                                           color="secondary">
                                    {{ $t('buttons.save') }}
                                  </CButton>
                                </CCol>
                              </CRow>

                            </CCol>
                        </CRow>


                    </CCardHeader>
                    <div v-show="false" :id="header_id"
                         style="margin-right: 50px;margin-left: 50px;margin-bottom: 70px">
                        <CCol>
                            <CRow style="justify-content:center">
                                <strong style="font-size: large">{{get_bussiness_name()}}</strong>
                            </CRow>

                            <CRow style="justify-content:center">
                                <strong>{{$t('sidebars.listProduct')}}</strong>
                            </CRow>
                            <CRow>

                            </CRow>

                        </CCol>

                    </div>
                    <div v-show="false" :id="footer_id" class="border-dark">
                        <CCardHeader>
                            <CRow style="border: 1px solid #000">


                                <CCol sm="4" md="4" style="text-align: start">
                                    <h2>{{ $t('docCreator') }} : {{ get_user_name() }}</h2>
                                </CCol>
                                <CCol sm="4" md="4" style="text-align: center">
                                    <h2 id="pageFooter" class="pageFooter"></h2>
                                </CCol>
                                <CCol sm="4" md="4" style="text-align: end">
                                    <h2>
                                    </h2>
                                </CCol>
                            </CRow>

                        </CCardHeader>

                    </div>

                    <CCardBody :id="body_id">
                        <CRow>
                            <CCol col="3">
                                <CSelect
                                        :options="category_items"
                                        :label="$t('components.productCategory')"
                                        :value.sync="selected_category"
                                        horizontal
                                />
                            </CCol>
                          <CCol col="1">
                            <CButton @click="get_lists()" color="dark"
                                     size="sm">
                              <CIcon size="sm" name="cil-zoom"/>
                            </CButton>
                            </CCol>

                        </CRow>
                        <CDataTableFixed
                                :items="items_filtered"
                                :fields="fields"
                                @row-clicked="table_row_clicked"
                                :column-filter="get_filter_table"
                                border
                                height="400px"
                                striped
                                hover
                                sorter
                        >
                            <!--                          :items-per-page="10"-->
                            <!--                          :pagination="get_pagination"-->

                            <template #row="{item,index}">

                                <td>
                                    <h6 style="text-align: center">{{index+1}}</h6>

                                </td>

                            </template>

                            <template #customerPrice="{item}">
                                <td>
                                    <p style="float:right" v-if="item.porsant!=null">{{item.customerPrice}}</p>

                                </td>

                            </template>

                            <template #productCode="{item}">
                                <td>
                                    <p style="text-align:center">{{item.productCode}}</p>
                                </td>
                            </template>
                            <template #productName="{item}">
                                <td>
                                  <a href="javascript:void(0)" class="text-primary" v-on:click="goEditProduct(item)">
                                    {{ item.productName }}
                                  </a>
                                </td>
                            </template>

                            <template #placeName="{item}">
                                <td>
                                    <p>{{item.placeName}}</p>
                                </td>
                            </template>

                            <template #adjustQty="{item,index}">

                                <td>
                                    <CInputCurrency v-model="item.adjustQty"
                                                    :whitout_decimal="true"
                                                    :id="'adjustqty'+index"
                                                    v-on:keypress.enter="focusNext_table('adjustqty',index)"
                                    />

                                </td>

                            </template>
                            <template #existence_value="{item,index}">

                                <td v-if="get_access('inventory_adjustment_in_pack')">
                                  <CRow >
                                    <CCol col="5">
                                      <p v-if="item.send_in_pack" style="float:right">{{get_currency(item.existence_value)}} </p>
                                      <p v-else style="float:right">{{get_currency(item.existence_value*item.value)}} </p>

                                    </CCol>
                                    <CCol col="7" >
                                      <CRow form class="form-group">
                                        <CCol tag="label" sm="5" class="col-form-label">
                                          {{ $t('SendInPack') }}
                                        </CCol>
                                        <CCol sm="7">
                                          <input type="checkbox" value="1" :checked.sync="item.send_in_pack" @input="change_is_pack(item.row_id,...arguments)"
                                                           />
                                        </CCol>
                                      </CRow>
                                    </CCol>
                                  </CRow>

                                </td>
<td v-else>
  <p  style="float:right">{{get_currency(item.existence_value)}} </p>

</td>
                            </template>
                            <template #image="{item}">


                                <td>
                                    <CImg width="45px" height="45px" v-bind:src="$root.base_url+'/'+item.imageName"/>
                                </td>

                            </template>

                            <template #operation="{item,index}">
                                <td>
                                    <CButton
                                            square
                                            size="sm"
                                            :title="$t('buttons.edit')"

                                    >
                                        <CIcon class="mr-1 text-primary" @click.native="goEditProduct(item,index)"
                                               size="sm" name="cil-pencil"/>
                                    </CButton>
                                    <CButton
                                            square
                                            :title="$t('buttons.delete')"
                                            size="sm"

                                    >
                                        <CIcon v-if="fields_data!='all'" @click.native="delete_item_dialog(item)"
                                               class="text-danger mr-1" size="sm" name="cilTrash"/>
                                    </CButton>

                                </td>
                            </template>


                        </CDataTableFixed>
                    </CCardBody>

                </CCard>
            </CCol>
            <CModal
                    :show.sync="change_refer_modal"
                    :no-close-on-backdrop="true"
                    color="transparent"
                    border-color="primary"
                    size="sm"
                    :title="$t('components.changeStatus')"
            >

                <CRow>
                    <CCol col="12">

                        <CRow>
                            <CCol col="4">
                                <label>{{$t('docDate')}}</label>
                            </CCol>
                            <CCol col="8">
                                <date-picker
                                        v-model="doc_date"
                                />
                            </CCol>
                        </CRow>
                        <CRow form class="form-group" v-if="1==0">
                            <CCol tag="label" sm="3" class="col-form-label">
                                {{ $t('user') }}
                            </CCol>
                            <CCol sm="9">
                                <treeselect
                                        v-model="refer_person"
                                        :async="true"
                                        :load-options="load_persons"
                                        :placeholder="$t('search')"
                                        :normalizer="normalizer_persons"
                                />

                            </CCol>
                        </CRow>

                        <!--          <CInput-->
                        <!--              :label="$t('components.summary')"-->
                        <!--              horizontal-->
                        <!--              v-model="change_status_summary"-->
                        <!--          />-->


                    </CCol>
                </CRow>
                <template #footer>
                    <CButton @click="insert_inventory_lists()"
                             color="success"
                    >{{ $t("buttons.ok") }}
                    </CButton>
                    <CButton
                            @click="change_refer_modal = false"
                            color="danger"
                    >{{ $t("buttons.cancel") }}
                    </CButton>
                </template>
            </CModal>

        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'


    import Vue from "vue";
    import JsonExcel from "vue-excel-ultra";

    var simulateAsync = null
    const simulateAsyncOperation = fn => {
        if (simulateAsync != null) {
            clearTimeout(simulateAsync)
        }
        simulateAsync = setTimeout(fn, 1000)
    }
    Vue.component("downloadExcel", JsonExcel);
    export default {
        name: 'ProductList',
        props: {
            fields_data: String
        },
        components: {
            Treeselect,
        },
        data() {
            return {
                header_id: "print_report_header_products" + new Date().getTime() + this.$vnode.tag,
                footer_id: "print_report_footer_products" + new Date().getTime() + this.$vnode.tag,
                body_id: "print_report_body_products" + new Date().getTime() + this.$vnode.tag,

                change_refer_modal: false,
                VUE_APP_Weight: localStorage.getItem('weight'),
                table_clicks: 0,
                table_clicks_timer: '',
                name: '',
                file: '',
                refer_person: 0,
                json_data: [],
                color: '#ffffff',
                previewImage: '',
                selected_template: 0,
                description: '',
                search_text: '',
                category_items: [],
                selected_category: 0,
                items: [],
                items_filtered: [],
                fields: [
                    {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:2%;text-align: center'},
                    {key: 'productCode', label: this.$t('tables.code'), _style: 'width:5%'},
                    {key: 'productName', label: this.$t('itemName'), _style: 'width:12%'},
                    // {key: 'customerPrice',label:this.$t('customerPrice'), _style: 'width:7%'},
                    {key: 'placeName', label: this.$t('inventory'), _style: 'width:6%'},
                    {key: 'existence_value', label: this.$t('components.existence'), _style: 'width:3%'},
                    {key: 'adjustQty', label: this.$t('adjustQty'), _style: 'width:5%;'},

                ],


                details: [],

                collapseDuration: 0,
                status_form: 0,
                doc_date: 0,
                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', false);
                            formData.append('IsWorker', true);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                            })
                                .catch(function (error) {

                                    console.log(error);
                                });

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
                    }
                },
            }
        },
        mounted() {
            this.doc_date = this.get_today();


            this.$root.root_validate_errors = [];

            this.get_lists();

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
          'selected_category':function (){
           this.items_filtered = this.selected_category==0 ? this.items : this.items.filter(x=>x.catRelId == this.selected_category)
          }
      },
        methods: {
          change_is_pack(index,e){
           // var itms = this.selected_category==0 ? this.items : this.items.filter(x=>x.catRelId == this.selected_category)
           //  Vue.set(this.selected_category==0 ? this.items[index] : this.items.filter(x=>x.catRelId == this.selected_category)[index],'send_in_pack',e.target.checked)
            Vue.set(this.items_filtered[index],'send_in_pack',e.target.checked)
console.log("changed",index)

          },
            focusNext_table( id,index) {
                document.getElementById("" + id + (index + 1)).focus()
                // elem = elem.srcElement
                // const currentIndex = Array.from(elem.form.elements).indexOf(elem);
                // elem.form.elements.item(currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0).focus();
                // if (elem.form.elements.item(currentIndex < elem.form.elements.length - 1 ? currentIndex + 1 : 0).disabled == true) {
                //     console.log("salam is desabled")
                // }
            },
            table_row_clicked(item, index, column) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.table_clicks = 0

                    // this.goEditProduct(item)
                }
            },
          goEditProduct(item, index) {

            window.open('/dashboard/products/edit/' + item.id)

          },
            get_categories() {
              var self = this;

              this.$apis.get_cats().then(result => {
                self.category_items = result

              })
            },
            get_lists() {
                var self = this;


                const formData = new FormData();

                var url = "GetProducts";
                if (self.$route.params.cat_id != null) {
                    url = "GetProductsByCatId";
                    formData.append('id', self.$route.params.cat_id);

                }
                if (self.$route.params.brand_id != null) {
                    url = "GetProducts";
                    formData.append('BrandId', self.$route.params.brand_id);

                }

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        self.items.forEach(function (val) {
                          val.send_in_pack = true
                            // val.existence_value = val.existence / val.value
                            // val.existence_value = val.existence / val.value
                            val.existence_value = val.packStock
                        })
self.items_filtered = JSON.parse(JSON.stringify(self.items))
                        self.get_categories();
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            insert_inventory_lists() {
                var self = this;
                var pros = [];
                self.items_filtered.forEach(function (val) {
                    if (val.adjustQty != null && val.adjustQty != "") {
                      let qty = val.send_in_pack ? val.adjustQty - val.existence_value : (val.adjustQty - val.existence_value)*val.value
                        pros.push({
                          ProductId: val.id,
                          PlaceId: val.placeId,
                          Qty: qty,
                          IsPack:val.send_in_pack? 1:0
                        })
                    }
                })

                const formData = new FormData();
                formData.append("input", JSON.stringify(pros))
                formData.append("PersonId", this.refer_person)
                formData.append("docDate", this.doc_date)
                var url = "AddInventoryAdjustment";

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    self.change_refer_modal = false

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.get_lists()
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

        }
    }

</script>
